<template>
  <div class="mt-3">
    <cool-label>New Filter</cool-label>
    <search-dropdown v-model="filter.field" :options="allFields" placeholder="Select field" optionValueField="value" optionLabelField="text" />
    <b-select class="my-2" v-model="filter.operator" :options="getOperatorOptions(filter.field)">
      <template slot="first">
        <option :value="''" disabled>Select operator</option>
      </template>
    </b-select>

    <filter-value-selector @addFilter="addFilter" v-model="filter.value" :field="filter.field" :start-time="startTime" :end-time="endTime">
    </filter-value-selector>

    <b-btn :disabled="!readyToAdd" class="my-3" @click="addFilter" variant="primary">Add Filter</b-btn>
  </div>
</template>

<script>
import { getAllFields, getFieldOptions, operatorOptions, getOperatorOptions, getProcessedValue, getFieldFormat } from '@/reports/components/ReportUtils'
import FilterValueSelector from '@/reports/components/FilterValueSelector'
import SearchDropdown from '@/components/SearchDropdown'


export default {
  props: {
    filters: { required: true, type: Array },
    startTime: { required: false, type: Number },
    endTime: { required: false, type: Number }
  },
  created() {
    this.resetForm()
  },
  data () {
    return {
      toggleClass: 'hidden',
      operatorOptions,
      fieldOptions: getFieldOptions(),
      allFields: getAllFields(),
      filter: {
        field: '',
        operator: 'EQUAL',
        value: ''
      },

    }
  },
  computed: {
    processedFilter() {
      let newFilter = Object.assign({}, this.filter)
      newFilter.value = this.getProcessedValue(newFilter.value, newFilter.field)
      return newFilter
    },
    readyToAdd() {
      for(let attr in this.filter) {
        if (this.filter[attr] === null || this.filter[attr] === '') {
          return false
        }
      }
      return true
    },
    fieldFormat() {
      return this.getFieldFormat(this.filter.field)
    }
  },
  watch: {
    fieldFormat: function() {
      this.filter.value = ''
    }
  },
  methods: {
    onInputChange(text, oldText){
    },
    setNewValue(option) {
      this.filter.value = option
    },
    addFilter() {
      this.filters.push(this.processedFilter)
      this.resetForm()
    },
    resetForm(){
      this.filter.value = ''
    },
    getProcessedValue,
    getOperatorOptions,
    getFieldFormat
  },
  components: {
    FilterValueSelector,
    SearchDropdown
  }
}
</script>



// WEBPACK FOOTER //
// src/reports/components/FilterSelector.vue